/**
 * Placeholder social proof (contract §7): "Nara and Anisa are going to this
 * event with 36 others." Deterministic from the event's id, so the same event
 * always names the same people. Faked, so the UI always marks it **Sample**
 * (Sam's rule: every faked value on screen carries the marker).
 */

const NAMES = [
  'Nara', 'Anisa', 'Mateo', 'Priya', 'Jamal', 'Sofia', 'Kenji', 'Amara',
  'Diego', 'Leila', 'Owen', 'Zainab', 'Theo', 'Mei', 'Kofi', 'Ines',
  'Ravi', 'Hana', 'Luca', 'Yara', 'Andre', 'Noor', 'Sam', 'Camila',
];

export interface SampleAttendance {
  names: [string, string];
  /** 4..60 */
  others: number;
}

/** FNV-1a: small, stable, and good enough to spread ids across the pool. */
function hash(text: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < text.length; i++) {
    h ^= text.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}

export function sampleAttendance(id: string): SampleAttendance {
  const h = hash(id);
  const first = h % NAMES.length;
  // Never the same name twice.
  const second = (first + 1 + ((h >>> 8) % (NAMES.length - 1))) % NAMES.length;
  return { names: [NAMES[first], NAMES[second]], others: 4 + ((h >>> 16) % 57) };
}

/** The sentence, without the marker (the caller draws that). */
export function sampleAttendanceText(id: string): string {
  const { names, others } = sampleAttendance(id);
  return `${names[0]} and ${names[1]} are going to this event with ${others} others.`;
}
